export default __webpack_public_path__ + "e3fdb2b0e2600833f108e698502ccfcf.png";